import React from 'react';

import Grid from 'brandComponents/Grid';

import {EGridSpacing, IGridContentfulProps} from './IGridContentful';
import {GridContentfulColumn, GridContentfulRow} from './Subcomponents';

const GridContentful = (props: IGridContentfulProps) => {
	const attrs = {classNames: 'cf-grid'};

	if (props.isFluid) {
		attrs['fluid'] = true;
	}

	if (props.verticalGutters) {
		attrs['verticalGutters'] = EGridSpacing[props.verticalGutters];
	}

	if (!props.children) {
		return null;
	}

	return <Grid {...attrs}>{props.children}</Grid>;
};

GridContentful.Row = GridContentfulRow;
GridContentful.Column = GridContentfulColumn;

export default GridContentful;
